import { createReducer } from '@reduxjs/toolkit';
import {
  listIncomingRequests,
  searchIncomingRequests,
  filterIncomingRequests,
  exportIncomingRequests,
  getIncomingRequestInfo,
  updateIncomingRequestInfo,
  requeryIncomingRequest,
  addIncomingRequest,
} from '../actions/incomingRequest';

const initialState = {
  incomingRequests: {
    data: [],            // List of incoming requests (includes filtered or search results)
    currentPage: 1,      // Current page for pagination
    totalRecords: 0,     // Total number of records
    pageSize: 10,        // Items per page
  },
  loading: false,        // Loading state for listing, filtering, searching, and exporting incoming requests
  error: null,           // General error state

  export: {
    loading: false,      // Loading state for export action
    success: false,      // Tracks if export was successful
    error: null,         // Export-specific error
  },

  viewDetails: {
    data: null,
    error: null,
  },
  updateInfo: {
    success: false,
    error: null,
  },
  requery: {
    success: false,
    error: null,
    loading: false
  },
  addIncomingRequest: {
    success: false,
    error: null,
  },
};

const incomingRequestsReducer = createReducer(initialState, (builder) => {
  builder
  .addCase(String(listIncomingRequests.trigger), (state) => {
    state.loading = true;
    state.error = null;
  })
  .addCase(String(listIncomingRequests.resolved), (state, action) => {
    const { 
      data: incomingRequests, 
      current_page: currentPage, 
      next_page_url: nextPageUrl, 
      prev_page_url: prevPageUrl, 
      total: totalRecords, 
      per_page: pageSize 
    } = action.payload;

    state.loading = false;
    state.incomingRequests = {
      data: incomingRequests,
      currentPage,
      totalRecords, 
      pageSize,  
      nextPageUrl,
      prevPageUrl   
    };
  })
  .addCase(String(listIncomingRequests.rejected), (state, action) => {
    state.loading = false;
    state.error = action.payload;
  })

  // Filter incoming requests
  .addCase(String(filterIncomingRequests.trigger), (state) => {
    state.loading = true;
    state.error = null;
  })
  .addCase(String(filterIncomingRequests.resolved), (state, action) => {
    const { incomingRequests, currentPage, totalRecords, pageSize } = action.payload;
    state.loading = false;
    state.incomingRequests = {
      data: incomingRequests,
      currentPage,
      totalRecords,
      pageSize,
    };
  })
  .addCase(String(filterIncomingRequests.rejected), (state, action) => {
    state.loading = false;
    state.error = action.payload;
  })

  // Search incoming requests
  .addCase(String(searchIncomingRequests.trigger), (state) => {
    state.loading = true;
    state.error = null;
  })
  .addCase(String(searchIncomingRequests.resolved), (state, action) => {
    const { incomingRequests, currentPage, totalRecords, pageSize } = action.payload;
    state.loading = false;
    state.incomingRequests = {
      data: incomingRequests,
      currentPage,
      totalRecords,
      pageSize,
    };
  })
  .addCase(String(searchIncomingRequests.rejected), (state, action) => {
    state.loading = false;
    state.error = action.payload;
  })

  // Export incoming requests
  .addCase(String(exportIncomingRequests.trigger), (state) => {
    state.export.loading = true;
    state.export.success = false;
    state.export.error = null;
  })
  .addCase(String(exportIncomingRequests.resolved), (state) => {
    state.export.loading = false;
    state.export.success = true;
  })
  .addCase(String(exportIncomingRequests.rejected), (state, action) => {
    state.export.loading = false;
    state.export.success = false;
    state.export.error = action.payload;
  })

  // View incoming request details
  .addCase(String(getIncomingRequestInfo.trigger), (state) => {
    state.viewDetails.error = null;
  })
  .addCase(String(getIncomingRequestInfo.resolved), (state, action) => {
    state.viewDetails.data = action.payload;
  })
  .addCase(String(getIncomingRequestInfo.rejected), (state, action) => {
    state.viewDetails.error = action.payload;
  })

  // Update incoming request info
  .addCase(String(updateIncomingRequestInfo.trigger), (state) => {
    state.updateInfo.error = null;
  })
  .addCase(String(updateIncomingRequestInfo.resolved), (state) => {
    state.updateInfo.success = true;
  })
  .addCase(String(updateIncomingRequestInfo.rejected), (state, action) => {
    state.updateInfo.success = false;
    state.updateInfo.error = action.payload;
  })

  // Update incoming request balance
  .addCase(String(requeryIncomingRequest.trigger), (state) => {
    state.requery.error = null;
    state.requery.loading = true;
  })
  .addCase(String(requeryIncomingRequest.resolved), (state) => {
    state.requery.success = true;
    state.requery.loading = false;
  })
  .addCase(String(requeryIncomingRequest.rejected), (state, action) => {
    state.requery.success = false;
    state.requery.error = action.payload;
    state.requery.loading = false;
  })

  // Add incoming request
  .addCase(String(addIncomingRequest.trigger), (state) => {
    state.addIncomingRequest.error = null;
  })
  .addCase(String(addIncomingRequest.resolved), (state) => {
    state.addIncomingRequest.success = true;
  })
  .addCase(String(addIncomingRequest.rejected), (state, action) => {
    state.addIncomingRequest.success = false;
    state.addIncomingRequest.error = action.payload;
  })
});

export default incomingRequestsReducer;
